import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ClientCompanyModel } from 'src/Models/ClientCompanyModel';
import { UserHistoryReportFilter } from 'src/Models/filterModel';
import { CheckAuth } from 'src/Services/utility.service';
import { UserHistoryReportsModel } from 'src/Models/usersModel';
import { UsersService } from 'src/Services/users.service';
import { Router } from '@angular/router';
import * as moment from 'moment';
import * as FileSaver from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-user-history-report',
  templateUrl: './user-history-report.component.html',
  styleUrls: ['./user-history-report.component.css']
})
export class UserHistoryReportComponent implements OnInit {
  filterModel = new UserHistoryReportFilter();
  currentPage: number = 1;
  totalRecordCount: number = -1;

  listOfUser: UserHistoryReportsModel[];
  listOfUserExport: UserHistoryReportsModel[];
  tokenKey: string = '';
  SelectedTool: string;

  isAscending: boolean = false
  upDownNameCSS: string = '';
  upDowURLCSS: string = '';
  upDownPageNameCSS: string = '';
  upDownActionNameCSS: string = '';
  upDownActionUrlCSS: string = '';
  upDownIpAddressCSS: string = '';
  upDowCreatedDateCSS: string = '';
  upDownCompanyNameCSS: string = '';
  upDowIsDemoCSS: string = '';
  upDowIsCompCSS: string = '';

  isloading: boolean;
  dropdownSettingsActionName = {};
  dropdownListActionName = [];
  selecteddropdownListActionName = [];

  dropdownSettingsActionTypeName = {};
  dropdownListActionTypeName = [];
  selecteddropdownListActionTypeName = [];

  dropdownSettingsProduct = {};
  dropdownListProduct = [];
  selecteddropdownListProduct = [];

  clientCompanyList: ClientCompanyModel[];
  dropdownListclientCompany = [];
  selectedItemsclientCompany = [];
  dropdownSettingclientCompany = {};
  listOfCompany = [];

  loginUserId: number = 0;
  systemUserCondition: string = '';
  isShowprogressSpinner: boolean;
  blockedDocument: boolean;
  rangeOfupdatesDates: any;
  openMenuIndex: number = -1

  constructor(private readonly userService: UsersService,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly router: Router,
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.titleService.setTitle('User History Report');
    this.filterModel.PageNumber = 1;
    this.filterModel.PageSize = 10;

  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.setCurrentMonthDateRange();
    //this.GetUserHistoryReport();
  }

  GetUserHistoryReport() {
    this.filterModel.IsExport = false;
    this.listOfUser = [];
    this.isloading = true;
    this.userService.GetUserhistoryReport(this.tokenKey, this.filterModel).subscribe(
      data => {
        this.isloading = false;
        if (data != null) {
          this.listOfUser = data['userhistoryReports'];
          if (this.listOfUser != null) {
            if (this.listOfUser.length > 0) {
              this.totalRecordCount = this.listOfUser[0].totalRecordCount;
            }
            else {
              this.totalRecordCount = 0;
            }
          }
          else {
            this.totalRecordCount = 0;
          }
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  keywordFilters() {
    this.filterModel.PageNumber = 1;
    this.currentPage = 1;
    this.GetUserHistoryReport();
  }



  pageChanged($event: any) {
    this.currentPage = $event.page;
    this.filterModel.PageNumber = parseInt($event.page);
    this.GetUserHistoryReport();
  }

  cleanCssClass() {
    this.upDownNameCSS = '';
    this.upDownPageNameCSS = '';
    this.upDownActionNameCSS = '';
    this.upDownActionUrlCSS = '';
    this.upDownIpAddressCSS = '';
    this.upDowCreatedDateCSS = '';
    this.upDownCompanyNameCSS = '';
    this.upDowIsDemoCSS = '';
    this.upDowIsCompCSS = '';
  }


  sort(sortBy: any) {
    this.cleanCssClass();
    this.isAscending = !this.isAscending;
    //this.filterModel.orderBy = this.isAscending ? sortBy : sortBy + ' DESC';

    switch (sortBy) {
      case "FullName": this.upDownNameCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
      case "ProductName": this.upDownPageNameCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
      case "ActionName": this.upDownActionNameCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
      case "ActionUrl": this.upDownActionUrlCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
      case "IpAddress": this.upDownIpAddressCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
      case "CreatedDate": this.upDowCreatedDateCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
      case "CompanyName": this.upDownCompanyNameCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
      case "isDemo": this.upDowIsDemoCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
      case "isComp": this.upDowIsCompCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
      default: break;
    }
    this.currentPage = 1;
    this.filterModel.PageNumber = 1;
    this.GetUserHistoryReport();
  }

  isUpdatesDatesFilter(value: any) {
    if (value != null) {
      if (value.length == 2) {
        this.filterModel.PageNumber = 1;
        this.currentPage = 1;
        const d = new Date(value[0]);
        const a = [this.pad(d.getMonth() + 1), this.pad(d.getDate()), d.getFullYear()].join('/');

        const e = new Date(value[1]);
        const f = [this.pad(e.getMonth() + 1), this.pad(e.getDate()), e.getFullYear()].join('/');

        this.filterModel.FromDate = a;
        this.filterModel.ToDate = f;
        this.GetUserHistoryReport();
      }
      else {
        this.filterModel.PageNumber = 1;
        this.filterModel.FromDate = "";
        this.filterModel.ToDate = "";
      }
    }
    else {
      this.filterModel.PageNumber = 1;
      this.filterModel.FromDate = "";
      this.filterModel.ToDate = "";
    }
  }

  setCurrentMonthDateRange() {
    const startOfMonth = moment().startOf('month').toDate();
    const endOfMonth = moment().endOf('month').toDate();
    this.rangeOfupdatesDates = [startOfMonth, endOfMonth];
  }

  pad(s) {
    return (s < 10) ? '0' + s : s;
  }

  clearUpdateDate() {
    this.rangeOfupdatesDates = [];
    this.filterModel.PageNumber = 1;
    this.filterModel.FromDate = '';
    this.filterModel.ToDate = '';
    this.GetUserHistoryReport();
  }

  viewHistory(user) {
    sessionStorage.setItem('viewUserName', user.firstName + ' ' + user.lastName);
    let navigation = '/admin/Admin/subscriber/history/' + user.recordId;
    this.router.navigate([navigation]);
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportUserHistory() {
    this.filterModel.IsExport = true;
    this.listOfUserExport = [];
    this.isloading = true;
    this.userService.GetUserhistoryReport(this.tokenKey, this.filterModel).subscribe(
      data => {
        if (data != null) {
          this.listOfUserExport = data['userhistoryReports'];
          if (this.listOfUserExport.length > 0) {
            setTimeout(() => {
              this.DownloadUserHistory();
              this.isloading = false;
            }, 2000);
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
        else {
          this.isloading = false;
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  DownloadUserHistory() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportAdminUserHistoryReport';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportAdminUserHistoryReport.xls");
  }

}
